import { defineAction } from '~/prix'
import roadMaintenanceImageCreateAction from './roadMaintenanceImageCreate.action.json' with { type: 'json' }
import { acceptedFormat, roadMaintenanceImageObject } from '../roadMaintenanceImageObject'
import { z } from 'zod'

const definition = defineAction({
  ...roadMaintenanceImageCreateAction,
  input: roadMaintenanceImageObject
    .pick({ id: true, roadMaintenanceId: true, description: true, position: true })
    .partial({ id: true })
    .extend({
      format: acceptedFormat,
    }),
  output: z.object({
    publicUrl: z.string().nullish(),
    uploadUrl: z.string().nullish(),
  }),
})

export default definition
